import { TextInput } from "@carbon/react";
import { Controller, UseFormReturn, useWatch } from "react-hook-form";

import { SimleRuleFormData } from "./useSimpleRuleDefinition";

export type SimpleRuleValueFormFieldProps = {
  index: number;
  id: string;
  methods: UseFormReturn<SimleRuleFormData>;
};

export function SimpleRuleValueFormField({ index, id, methods }: SimpleRuleValueFormFieldProps) {
  const { control, formState } = methods;

  const currentOperator = useWatch({ control, name: "criteria" })[index].operator;

  const operatorNeedsValue =
    currentOperator?.code !== "empty" && currentOperator?.code !== "nonEmpty";
  const isSelectPropertyAndOperator =
    formState?.dirtyFields?.criteria?.[index].operator &&
    formState?.dirtyFields?.criteria?.[index].property;

  return (
    <Controller
      name={`criteria.${index}.value`}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <TextInput
            id={`value-${id}`}
            labelText=""
            placeholder={operatorNeedsValue ? "Valeur" : "Non requis"}
            value={field.value ?? ""}
            onChange={(e) => {
              field.onChange(e.target.value);
            }}
            disabled={!operatorNeedsValue || !isSelectPropertyAndOperator}
            invalid={!!fieldState.error}
            invalidText={fieldState.error?.message}
          />
        );
      }}
    />
  );
}
